<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!gates.length" class="dw-empty">No on-time data for this period.</div>
    <template v-else>
      <div class="dw-stat-grid">
        <div v-for="gate in gates" :key="gate.key" class="dw-stat-tile">
          <div class="dw-stat-tile-label">{{ gate.label }}</div>
          <div class="dw-stat-tile-value" :class="pctClass(gate.pct)">
            {{ gate.pct }}%
            <small>({{ gate.on_time_count }}/{{ gate.count }})</small>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import { get_actuals_on_time_report } from '../../networking/apis'
import { get_tbn_actuals_on_time_report } from '../../networking/tbn_apis'

// same three on-time gates as the actuals stats page / full report, at the
// same 0m default thresholds -- this widget is a read-only glance, not a
// place to reconfigure thresholds.
const GATE_DEFS = [
  { key: 'to_yard', label: 'To Yard' },
  { key: 'depart_yard', label: 'Depart Yard' },
  { key: 'to_pickup', label: 'To Pickup' },
]

export default {
  name: 'widget_driver_on_time',
  props: {
    tenant: { type: String, required: true },
    isCmTenant: { type: Boolean, default: true },
    daysRange: { type: Number, default: 7 },
  },
  data() {
    return {
      loading: true,
      onTimeMetrics: {},
    }
  },
  computed: {
    fromDate() {
      // inclusive of today, so a 3d selection covers 3 days rather than 4 --
      // same window main_dashboard.vue's range_start_date() hands the other
      // date-scoped widgets, and the same one the See more link opens with
      return moment().subtract(this.daysRange - 1, 'days').format('YYYY-MM-DD')
    },
    toDate() {
      return moment().format('YYYY-MM-DD')
    },
    gates() {
      return GATE_DEFS
        .map(def => ({ ...def, ...(this.onTimeMetrics[def.key] || {}), pct: (this.onTimeMetrics[def.key] || {}).on_time_pct }))
        .filter(gate => gate.count > 0)
    },
  },
  created() {
    this.load()
  },
  methods: {
    pctClass(pct) {
      if (pct == null) return ''
      if (pct >= 90) return 'dw-stat-tile-value--good'
      if (pct < 70) return 'dw-stat-tile-value--bad'
      return ''
    },
    async load() {
      this.loading = true
      try {
        const fetch = this.isCmTenant
          ? get_actuals_on_time_report(this.tenant, this.fromDate, this.toDate, 'finish', '', '', 0, 0, 0)
          : get_tbn_actuals_on_time_report(this.tenant, this.fromDate, this.toDate, 'finish', '', 0, 0, 0)
        const { value: { data = {} } } = await fetch
        this.onTimeMetrics = data.on_time_metrics || {}
      } catch (e) {
        this.onTimeMetrics = {}
      }
      this.loading = false
    },
  },
  watch: {
    daysRange() {
      this.load()
    },
  },
}
</script>
